export enum NaryTreeTraversalOrder {
    PreOrder = 'PreOrder',
    PostOrder = 'PostOrder'
}

export enum AlgorithmModes {
    Flush,
    Adaptive = 'adaptive'
}

export enum ChildrenProperties {
    components = 'components',
    hiddenComponents = 'hiddenComponents'
}

export enum Orientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}

export enum StageName {
    HIDE_COMPONENTS = 'HIDE_COMPONENTS',
    GROUPING = 'GROUPING',
    GROUPING_ORDER = 'GROUPING_ORDER',
    STRUCTURE_ORDER = 'STRUCTURE_ORDER',
    HORIZONTAL_LAYOUT_SCALE = 'HORIZONTAL_LAYOUT_SCALE',
    VERTICAL_LAYOUT_SCALE = 'VERTICAL_LAYOUT_SCALE',
    TRANSFORM_STYLE = 'TRANSFORM_STYLE',
    POST_PROCESS = 'POST_PROCESS'
}

export enum SkipPredicate {
    GROUPING_HASH = 'groupingHash'
}
